// extracted by mini-css-extract-plugin
export default {"wrapper":"cookieCategoryDetails_wrapper","text":"cookieCategoryDetails_text"};